<div class="view-container">
  <embed [src]="pdfSrc" type="application/pdf" />
</div>
